import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import {
  Box, Typography, Paper, Stack, Grid, Button, 
  Divider, Badge, TextField, Modal, IconButton,
  Avatar, Card, Fade
} from "@mui/material";
import { 
  X, Calendar, DollarSign, Tag, Mail, 
  Clock, CheckCircle, AlertCircle, Edit, FileText
} from "lucide-react";
import { modificarAdelanto } from "../../features/registroAdelantosSlice";
import { toast } from "react-toastify";
import SubirArchivoFinanzas from "../Archivos/SubirArchivoFinanzas";

const apiUrl = process.env.REACT_APP_API_BASE_URL;

const PALETTE = {
  ice: "#C2EDF0",
  aqua: "#00C0CA",
  teal: "#008B9C",
  dark: "#22404D",
  red: "#F65F4E",
  slate: "#94A3B8",
  pearl: "#F4F7F9"
};

const DetalleAdelanto = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Estados lógicos originales
  const [adelanto, setAdelanto] = useState(null);
  const [comentarioFinanzas, setComentarioFinanzas] = useState("");
  const [mostrarModalEditar, setMostrarModalEditar] = useState(false);
  const [mostrarModalDesaprobar, setMostrarModalDesaprobar] = useState(false);
  const [comentarioDesaprobar, setComentarioDesaprobar] = useState("");
  const [mostrarModal, setMostrarModal] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [dias, setDias] = useState(0);
  const [mostrarModalEliminar, setMostrarModalEliminar] = useState(false);
  const [formEditar, setFormEditar] = useState({
    id: 0, nombre: "", motivo: "", importe: 0, moneda: "", centroCosto: ""
  });

  useEffect(() => {
    const fetchAdelanto = async () => {
      try {
        const response = await fetch(`${apiUrl}/Adelanto/${id}`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json', 'apiKey': localStorage.getItem("apiKey") }
        });
        if (response.status === 200) {
          const data = await response.json();
          setAdelanto(data);
          setFormEditar({
            id: data.id || 0,
            nombre: data.nombre || "",
            motivo: data.motivo || "",
            importe: data.importe || 0,
            moneda: data.moneda || "",
            centroCosto: data.centroCosto || "",
          });
        } else { manejarErrores(response.status); }
      } catch (error) { manejarErrores(error.status); }
    };
    fetchAdelanto();
  }, [id]);

  useEffect(() => {
    if (adelanto) { calcularDiasQueFaltan(); }
  }, [adelanto]);

  // Lógica de cálculo y errores idéntica a la original
  const manejarErrores = (estatus) => {
    let msg = "Ocurrió un error inesperado.";
    if (estatus === 401 || estatus === 500) { localStorage.clear(); navigate("/"); }
    toast.error(msg, { position: "bottom-center" });
  };

  const calcularDiasQueFaltan = () => {
    const hoy = new Date();
    const fechaLimite = new Date(adelanto?.fecha);
    const termina = new Date(adelanto?.fecha);
    termina.setDate(fechaLimite.getDate() + adelanto.laRendicion.diasRendicion);
    const diferencia = termina - hoy;
    const d = Math.floor(diferencia / (1000 * 60 * 60 * 24));
    setDias(d >= 0 ? d : 0);
  };

  // Funciones de acción originales (sin cambiar lógica)
  const actualizarEstadoAdelanto = async () => {
  const apiKey = localStorage.getItem("apiKey");
  if (!apiKey) {
    console.error("No hay apiKey en localStorage");
    return;
  }
  if (!adelanto?.id) {
    console.error("adelanto.id es inválido:", adelanto);
    return;
  }

  try {
    const url = `${apiUrl}/Adelanto/CambiarEstado?id=${adelanto.id}`;
    const response = await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        apiKey: apiKey,
      },
    });

    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${await response.text()}`);
    }
    return response.ok;
  } catch (error) {
    console.error("Error al cambiar el estado del adelanto:", error);
    throw error;
  }
};

const eliminarAdelanto = async () => {
  try {
    const response = await fetch(`${apiUrl}/Adelanto/${adelanto.id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        apiKey: localStorage.getItem("apiKey"),
      },
    });
    if (response.ok) {
      toast.success("Adelanto eliminado", { position: "bottom-center", autoClose: 3000 });
      setMostrarModalEliminar(false);
      navigate("/adelantos"); // ajustá a tu ruta de listado
    } else {
      toast.error("No se pudo eliminar", { position: "bottom-center", autoClose: 3000 });
    }
  } catch (error) {
    console.error("Error al eliminar:", error);
    toast.error("Error al eliminar el adelanto", { position: "bottom-center", autoClose: 3000 });
  }
};
  const enviarDesaprobacion = async () => {
  try {
    const response = await fetch(`${apiUrl}/Adelanto/DesaprobarAdelanto?id=${adelanto.id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        apiKey: localStorage.getItem("apiKey"),
      },
    });
    if (response.ok) {
      toast.success("Adelanto desaprobado", { position: "bottom-center", autoClose: 3000 });
      setMostrarModalDesaprobar(false);
      setAdelanto((prev) => ({ ...prev, estado: "Desaprobado" }));
    } else {
      toast.error("No se pudo desaprobar", { position: "bottom-center", autoClose: 3000 });
    }
  } catch (error) {
    console.error("Error al enviar desaprobación:", error);
    toast.error("Error al enviar desaprobación", { position: "bottom-center", autoClose: 3000 });
  }
};
  const actualizarAdelanto = async () => {  try {
      const bodyToSend = { id: adelanto.id, ...formEditar };

      const response = await fetch(`${apiUrl}/Adelanto/editar/${adelanto.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(bodyToSend),
      });

      console.log("Respuesta del servidor:", response);
      if (response.ok) {
        toast.success("Adelanto actualizado exitosamente", { position: "bottom-center", autoClose: 3000 });
        setMostrarModalEditar(false);
        setAdelanto((prev) => ({ ...prev, ...formEditar }));
        dispatch(modificarAdelanto({ id: adelanto.id, ...formEditar }));
        setAdelanto((prev) => ({ ...prev, estado: "Pendiente" }));
      } else {
        toast.error("Error al actualizar el adelanto", { position: "bottom-center", autoClose: 3000 });
      }
    } catch {
      toast.error("Error en la solicitud de actualización", { position: "bottom-center", autoClose: 3000 });
    }};
  const revisarRendicion = async (ok) => {if (!mensaje) {
      toast.error("No puede dejar el mensaje vacío", {
        position: "bottom-center",
        autoClose: 3000,
      });

      return;
    }
    try {
      const response = await fetch(
        `${apiUrl}/Adelanto/revisarRendicion?id=${adelanto.id}&ok=${ok}&mensaje=${mensaje}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            apiKey: localStorage.getItem("apiKey"),
            
          },
        }
      );
      console.log(response.ok);
      if (response.ok) {
        setAdelanto((prevAdelanto) => ({
          ...prevAdelanto,
          laRendicion: {
            ...prevAdelanto.laRendicion,
            rendicionFinanzas: true,
          },
        }));
      if(ok){
        setAdelanto((prevAdelanto) => ({
          ...prevAdelanto,
          laRendicion: {
            ...prevAdelanto.laRendicion,
            mensaje:"Rendición aprobada: "+mensaje ,
          },
        }));
      }else{
        setAdelanto((prevAdelanto) => ({
          ...prevAdelanto,
          laRendicion: {
            ...prevAdelanto.laRendicion,
            mensaje:"Rendición reprobada: "+mensaje ,
          },
        }));


      }
      } else {
      }
    } catch (error) {
      toast.error("Error en la solicitud de actualización del estado.", {
        position: "bottom-center",
        autoClose: 3000,
      });
    } };
  const prorroga = async (d) => { const response = await fetch(
      `${apiUrl}/Adelanto/darProroga?id=${adelanto.id}&dias=${
        adelanto.laRendicion.diasRendicion + dias
      }`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    console.log(response);

    if (response.ok) {
      setAdelanto((prevAdelanto) => ({
        ...prevAdelanto,
        laRendicion: {
          ...prevAdelanto.laRendicion,
          diasRendicion: adelanto.laRendicion.diasRendicion + 5,
        },
      }));
    } };
  
  const obtenerColorDias = () => {
    if (dias > 10) return "#2e7d32"; // Success
    if (dias > 5) return "#ed6c02"; // Warning
    return "#d32f2f"; // Danger
  };

  const InfoItem = ({ icon: Icon, label, value, badge }) => (
    <Stack direction="row" spacing={2} alignItems="center" sx={{ py: 1.5 }}>
      <Avatar sx={{ bgcolor: `${PALETTE.aqua}10`, color: PALETTE.aqua, width: 42, height: 42, borderRadius: '14px' }}>
        <Icon size={20} />
      </Avatar>
      <Box sx={{ flexGrow: 1 }}>
        <Typography variant="caption" sx={{ color: PALETTE.slate, fontWeight: 800, textTransform: 'uppercase' }}>{label}</Typography>
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography variant="body1" sx={{ color: PALETTE.dark, fontWeight: 900 }}>{value}</Typography>
          {badge}
        </Stack>
      </Box>
    </Stack>
  );

  return (
    <Box sx={{ p: { xs: 2, md: 5 }, mt: "64px", bgcolor: "#F4F7F9", minHeight: "100vh" }}>
      <Typography variant="h4" sx={{ fontWeight: 900, color: PALETTE.dark, mb: 4 }}>
        Detalle de Adelanto
      </Typography>

      <Grid container spacing={4}>
        {/* COLUMNA IZQUIERDA: INFORMACIÓN PRINCIPAL */}
        <Grid item xs={12} md={8}>
          <Paper elevation={0} sx={{ p: 4, borderRadius: '32px', border: '1px solid rgba(0,0,0,0.05)' }}>
            <Typography variant="h5" sx={{ fontWeight: 900, color: PALETTE.teal, mb: 3 }}>
              {adelanto?.nombre || "Cargando..."}
            </Typography>
            
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <InfoItem icon={Tag} label="Motivo" value={adelanto?.motivo} />
                <Divider />
                <InfoItem icon={Calendar} label="Fecha" value={adelanto?.fecha.split("T")[0]} />
                <Divider />
                <InfoItem icon={DollarSign} label="Importe" value={`${adelanto?.importe} ${adelanto?.moneda}`} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <InfoItem icon={FileText} label="Centro de Costo" value={adelanto?.centroCosto} />
                <Divider />
                <InfoItem icon={Mail} label="Email" value={adelanto?.email} />
                <Divider />
                <InfoItem 
                  icon={AlertCircle} 
                  label="Estado" 
                  value={adelanto?.estado}
                  badge={<Badge sx={{ 
                    bgcolor: adelanto?.estado === "Aprobado" ? "#E8F5E9" : "#FFF3E0", 
                    color: adelanto?.estado === "Aprobado" ? "#2E7D32" : "#E65100",
                    px: 1.5, py: 0.5, borderRadius: '8px', fontSize: '0.65rem', fontWeight: 900
                  }}>{adelanto?.estado}</Badge>} 
                />
              </Grid>
            </Grid>

            {/* BOTONES DE ACCIÓN (Según lógica original) */}
            <Stack direction="row" spacing={2} sx={{ mt: 4 }}>
              {adelanto?.estado === "Pendiente" && localStorage.getItem("rol") === "finanzas" && (
                <>
                  <Button fullWidth variant="contained" onClick={actualizarEstadoAdelanto} sx={{ bgcolor: PALETTE.teal, borderRadius: '16px', fontWeight: 900 }}>Aprobar</Button>
                  <Button fullWidth variant="outlined" color="error" onClick={() => setMostrarModalDesaprobar(true)} sx={{ borderRadius: '16px', fontWeight: 900 }}>Desaprobar</Button>
                </>
              )}
              {adelanto?.estado === "Aprobado" && localStorage.getItem("rol") === "coordinador" && !adelanto.laRendicion.rendicioUsuario && (
                <Button fullWidth variant="contained" onClick={() => setMostrarModal(true)} sx={{ bgcolor: PALETTE.dark, borderRadius: '16px', fontWeight: 900, py: 1.5 }}>Añadir comprobante</Button>
              )}
              {localStorage.getItem("rol") === "coordinador" && adelanto?.estado === "Desaprobado" && (
                <Button fullWidth variant="contained" color="warning" onClick={() => setMostrarModalEditar(true)} sx={{ borderRadius: '16px', fontWeight: 900 }}>Editar Adelanto</Button>
              )}
              {adelanto?.estado === "Pendiente" && localStorage.getItem("rol") === "finanzas" && (
  <>
    <Button fullWidth variant="contained" color="error" onClick={() => setMostrarModalEliminar(true)} sx={{ bgcolor: PALETTE.red, borderRadius: '16px', fontWeight: 900 }}>Eliminar</Button>
  </>
)}
            </Stack>
          </Paper>
        </Grid>

        {/* COLUMNA DERECHA: TIEMPO Y RENDICIÓN */}
        <Grid item xs={12} md={4}>
          <Stack spacing={3}>
            {/* CARD DE TIEMPO */}
            {adelanto?.estado === "Aprobado" && (
              <Paper elevation={0} sx={{ 
                p: 3, borderRadius: '32px', bgcolor: obtenerColorDias(), color: 'white',
                boxShadow: `0 15px 30px ${obtenerColorDias()}40`
              }}>
                <Stack alignItems="center" spacing={1}>
                  <Clock size={32} />
                  <Typography variant="body2" sx={{ fontWeight: 800, opacity: 0.9 }}>Tiempo restante rendición</Typography>
                  <Typography variant="h3" sx={{ fontWeight: 900 }}>{dias} Días</Typography>
                  {localStorage.getItem("rol") === "finanzas" && !adelanto?.laRendicion?.rendicioUsuario && (
                    <Button variant="contained" sx={{ bgcolor: 'rgba(255,255,255,0.2)', mt: 2, borderRadius: '12px' }} onClick={() => prorroga(5)}>+ 5 Días de Prórroga</Button>
                  )}
                </Stack>
              </Paper>
            )}

            <Button fullWidth variant="contained" sx={{ bgcolor: '#4CAF50', borderRadius: '18px', py: 2, fontWeight: 900 }} onClick={() => navigate("/verRendicion/"+id)}>
              Ver Rendición Completa
            </Button>

            {/* STATUS DE RENDICIÓN */}
            {adelanto?.laRendicion?.mensaje && (
              <Paper elevation={0} sx={{ 
                p: 3, borderRadius: '24px', border: '2px solid', 
                borderColor: adelanto?.laRendicion.rendicionFinanzas ? '#4CAF50' : '#FF9800',
                bgcolor: 'white'
              }}>
                <Typography variant="caption" sx={{ color: PALETTE.slate, fontWeight: 900 }}>ESTADO RENDICIÓN</Typography>
                <Typography variant="body1" sx={{ fontWeight: 800, color: PALETTE.dark }}>{adelanto?.laRendicion?.mensaje}</Typography>
              </Paper>
            )}

            {/* REVISIÓN PARA FINANZAS */}
            {adelanto?.laRendicion?.rendicioUsuario && !adelanto?.laRendicion?.rendicionFinanzas && localStorage.getItem("rol") === "finanzas" && (
              <Paper elevation={0} sx={{ p: 3, borderRadius: '24px', border: '1px solid #E0E0E0' }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 900, mb: 2 }}>Revisar Rendición</Typography>
                <TextField fullWidth size="small" placeholder="Mensaje para el coordinador" value={mensaje} onChange={(e) => setMensaje(e.target.value)} sx={{ mb: 2 }} />
                <Stack direction="row" spacing={1}>
                  <Button fullWidth variant="contained" color="success" onClick={() => revisarRendicion(true)}>Aprobar</Button>
                  <Button fullWidth variant="contained" color="error" onClick={() => revisarRendicion(false)}>Reprobar</Button>
                </Stack>
              </Paper>
            )}
          </Stack>
        </Grid>
      </Grid>

      {/* MODAL ELIMINAR */}
<Modal open={mostrarModalEliminar} onClose={() => setMostrarModalEliminar(false)}>
  <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 400, bgcolor: 'white', borderRadius: '32px', p: 4, boxShadow: 24 }}>
    <Typography variant="h6" sx={{ fontWeight: 900, mb: 1 }}>¿Eliminar adelanto?</Typography>
    <Typography variant="body2" sx={{ color: PALETTE.slate, mb: 3 }}>
      Esta acción es permanente y no se puede deshacer. ¿Estás seguro?
    </Typography>
    <Stack direction="row" spacing={1}>
      <Button fullWidth variant="outlined" onClick={() => setMostrarModalEliminar(false)} sx={{ borderRadius: '12px' }}>Cancelar</Button>
      <Button fullWidth variant="contained" color="error" onClick={eliminarAdelanto} sx={{ borderRadius: '12px' }}>Sí, eliminar</Button>
    </Stack>
  </Box>
</Modal>

      {/* MODAL DESAPROBAR */}
<Modal open={mostrarModalDesaprobar} onClose={() => setMostrarModalDesaprobar(false)}>
  <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 400, bgcolor: 'white', borderRadius: '32px', p: 4, boxShadow: 24 }}>
    <Typography variant="h6" sx={{ fontWeight: 900, mb: 1 }}>¿Desaprobar adelanto?</Typography>
    <Typography variant="body2" sx={{ color: PALETTE.slate, mb: 3 }}>
      Esta acción cambiará el estado del adelanto a "Desaprobado". ¿Estás seguro?
    </Typography>
    <Stack direction="row" spacing={1}>
      <Button fullWidth variant="outlined" onClick={() => setMostrarModalDesaprobar(false)} sx={{ borderRadius: '12px' }}>Cancelar</Button>
      <Button fullWidth variant="contained" color="error" onClick={enviarDesaprobacion} sx={{ borderRadius: '12px' }}>Sí, desaprobar</Button>
    </Stack>
  </Box>
</Modal>

      {/* MODAL EDITAR (Estilo Dashboard) */}
      <Modal open={mostrarModalEditar} onClose={() => setMostrarModalEditar(false)}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 400, bgcolor: 'white', borderRadius: '32px', p: 4, boxShadow: 24 }}>
          <Typography variant="h6" sx={{ fontWeight: 900, mb: 3 }}>Editar Adelanto</Typography>
          <Stack spacing={2}>
            <TextField fullWidth label="Nombre" value={formEditar.nombre} onChange={(e) => setFormEditar({...formEditar, nombre: e.target.value})} />
            <TextField fullWidth label="Importe" type="number" value={formEditar.importe} onChange={(e) => setFormEditar({...formEditar, importe: e.target.value})} />
            <Button fullWidth variant="contained" sx={{ bgcolor: PALETTE.dark, borderRadius: '12px', py: 1.5 }} onClick={actualizarAdelanto}>Guardar Cambios</Button>
          </Stack>
        </Box>
      </Modal>

      {/* MODAL COMPROBANTE */}
      <Modal open={mostrarModal} onClose={() => setMostrarModal(false)}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 450, bgcolor: 'white', borderRadius: '32px', p: 4 }}>
          <Typography variant="h6" sx={{ fontWeight: 900, mb: 2 }}>Subir Comprobante</Typography>
          <SubirArchivoFinanzas adelantoId={id} actualizar={() => { setMostrarModal(false); /* recargar lógica si es necesario */ }} />
        </Box>
      </Modal>
      
    </Box>
  );
};

export default DetalleAdelanto;